// extracted by mini-css-extract-plugin
export default {"header":"head_header__7R8vt"};